import EmptyState from '@/components/linear/empty-state';
import PageToolbar from '@/components/linear/page-toolbar';
import { documentPath, documentsPath, projectPath } from '@/lib/linear-paths';
import { formatCompactTime } from '@/lib/time';
import type { WorkspaceDocument } from '@/types/document';
import type { Note } from '@/types/note';
import { Form, Link } from '@inertiajs/react';

interface DocumentNote extends Note {
  projectName?: string;
}

interface Props {
  documents?: WorkspaceDocument[];
  notes?: DocumentNote[];
}

export default function Index({ documents = [], notes = [] }: Props) {
  return (
    <div className="ln-page">
      <PageToolbar title="Documents" showNew={false} />
      <div className="ln-page-scroll">
        <Form
          method="post"
          action={documentsPath()}
          className="ln-settings-row"
          style={{ margin: 16 }}
        >
          {({ processing }) => (
            <>
              <input
                className="ln-filter-input"
                name="document[title]"
                placeholder="New document title"
                aria-label="Document title"
                required
                style={{ flex: 1 }}
              />
              <button type="submit" className="ln-primary-btn" disabled={processing}>
                Create
              </button>
            </>
          )}
        </Form>
        {documents.map((document) => (
          <Link key={document.id} href={documentPath(document.id)} className="ln-row" style={{ height: 52 }}>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div className="ln-row-title">{document.title}</div>
              <div className="ln-inbox-sub">
                {document.creator?.name ?? 'Someone'}
                {document.project ? ` · ${document.project.name}` : ''}
              </div>
            </div>
            <span className="ln-row-date">
              {formatCompactTime(document.updatedAt || document.createdAt)}
            </span>
          </Link>
        ))}
        {notes.map((note) => (
          <Link
            key={note.id}
            href={note.projectId ? projectPath(note.projectId) : '#'}
            className="ln-row"
            style={{ height: 56 }}
          >
            <div style={{ minWidth: 0, flex: 1 }}>
              <div className="ln-row-title">{note.projectName ?? 'Workspace'}</div>
              <div className="ln-inbox-sub">{note.body}</div>
            </div>
            <span className="ln-row-date">{formatCompactTime(note.createdAt)}</span>
          </Link>
        ))}
        {documents.length === 0 && notes.length === 0 ? (
          <EmptyState title="No documents" description="Write a brief or project note." />
        ) : null}
      </div>
    </div>
  );
}
